<template>
  <path 
    fill-rule="evenodd"
    clip-rule="evenodd" 
    d="M22.2971 6.61006C19.929 5.30018 17.7284 3.64647 15.6076 2.0281C15.1522 1.67814 15.0533 1.02508 15.4155 0.600094C15.7491
     0.146225 16.397 0.0696003 16.8235 0.390957C18.8774 1.96112 21.0052 3.57208 23.2671 4.81557C23.7511 5.07868 23.9361 5.70291
      23.6722 6.2021C23.4086 6.70099 22.7813 6.87288 22.2971 6.61006Z"
  />
  <path 
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.1867 19.6485C14.1963 19.7485 8.2161 19.0847 2.20301 19.3236C1.65396 19.3583 0.943626 18.6581 0.904295 17.5908C0.864895
     16.5235 1.38371 15.9083 1.96173 15.9022C7.98369 15.6543 13.9724 16.3094 19.9717 16.2004C20.5428 16.2013 21.527 17.7354
     21.527 17.7354C21.8074 18.5587 20.7578 19.6494 20.1867 19.6485Z"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15.1853 33.9207C16.9927 32.2633 18.7999 30.6058 20.6076 28.9481C21.0016 28.5489 21.6538 28.5839 22.0403 29.0037C22.4265
     29.4238 22.3806 30.0495 21.9863 30.449C20.176 32.1093 18.3662 33.7694 16.5563 35.4294C16.1332 35.8001 15.4832 35.7631 15.099 
     35.341C14.7437 34.9475 14.7625 34.2911 15.1853 33.9207Z"
  />
</template>

<script>
export default {

}
</script>

<style scoped>

    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
    }
</style>